import { useEffect, useRef } from 'react';

type ClarityWindow = Window &
  typeof globalThis & {
    [key: string]: {
      q: unknown[];
    };
  };

declare const window: ClarityWindow;

const CLARITY_SCRIPT_ID = 'clarity-sdk';

export const useClarityInitializeService = (project_id?: string) => {
  const project_id_ref = useRef(project_id);

  useEffect(() => {
    if (!project_id_ref.current) {
      return;
    }

    if (process.env.NODE_ENV === 'development') {
      return;
    }

    const initClarity = (project_id: string) => {
      if (document.getElementById(CLARITY_SCRIPT_ID)) {
        return;
      }

      (function (c: ClarityWindow, l: Document, a: string, r: string, i: string) {
        c[a] =
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          c[a] ||
          function (...args: unknown[]) {
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            (c[a].q = c[a].q || []).push(args);
          };
        const t = l.createElement(r) as HTMLScriptElement;
        t.id = CLARITY_SCRIPT_ID;
        t.async = true;
        t.src = 'https://www.clarity.ms/tag/' + i;
        const y = l.getElementsByTagName(r)[0];
        y.parentNode?.insertBefore(t, y);
      })(window, document, 'clarity', 'script', project_id);
    };

    const timeout = setTimeout(() => {
      if (!project_id_ref.current) {
        return;
      }

      initClarity(project_id_ref.current);
    }, 400);

    return () => {
      clearTimeout(timeout);
    };
  }, []);
};
